<template>
	<v-dialog v-model="show" max-width="600" persistent>
		<v-card class="custom-dialog-card">
			<div class="cropper-wrapper">
				<vue-cropper
					:key="src"
					ref="cropper"
					:src="src"
					:aspect-ratio="aspect"
					:style="cropperStyle"
					:auto-crop-area="1"
					:view-mode="2"
					:drag-mode="'crop'"
					:background="true"
					:guides="true"
					:movable="true"
					:zoomable="true"
					:crop-box-movable="true"
					:crop-box-resizable="true"
					:toggle-drag-mode-on-dblclick="false"
				/>
			</div>

			<div class="cropper-actions">
				<v-slider
					class="cropper-actions__slider"
					v-model="brightness"
          color="var(--primary_color)"
          track-color="var(--primary_color)"
          thumb-color="var(--primary_color)"
					:min="0.5"
					:max="2"
					:step="0.01"
					label="brightness"
				/>
				<v-slider
					class="cropper-actions__slider"
					v-model="contrast"
          color="var(--primary_color)"
          track-color="var(--primary_color)"
          thumb-color="var(--primary_color)"
					:min="0.5"
					:max="2"
					:step="0.01"
					label="contrast"
				/>
				<div class="cropper-actions__buttons">
					<button
						class="cropper-actions__buttons__close"
						type="button"
						@click="$emit('close')"
					>
						Cancel
					</button>
					<button
						class="cropper-actions__buttons__save"
						type="button"
						@click="emitCropped"
					>
						Save
					</button>
				</div>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import 'cropperjs/dist/cropper.css'
import VueCropper from 'vue-cropperjs'

export default {
	name: 'ImageCropper',
	components: { VueCropper },
	props: {
		src: { type: String, required: true },
		show: { type: Boolean, required: true },
		aspect: { type: Number, default: 16 / 9 },
	},
	data() {
		return {
			brightness: 1,
			contrast: 1,
		}
	},
	computed: {
		cropperStyle() {
			return {
				maxHeight: '400px',
				width: '100%',
				filter: `brightness(${this.brightness}) contrast(${this.contrast})`,
				objectFit: 'contain',
			}
		},
	},
	methods: {
		emitCropped() {
			const canvas = this.$refs.cropper.getCroppedCanvas()
			const filteredCanvas = document.createElement('canvas')
			filteredCanvas.width = canvas.width
			filteredCanvas.height = canvas.height
			const ctx = filteredCanvas.getContext('2d')

			ctx.filter = `brightness(${this.brightness}) contrast(${this.contrast})`
			ctx.drawImage(canvas, 0, 0)

			filteredCanvas.toBlob(
				(blob) => {
					this.$emit('cropped', blob)
				},
				'image/jpeg',
				0.9
			)
		},
	},
}
</script>

<style lang="scss">
.custom-dialog-card {
	max-height: 90vh;
	overflow: hidden;
	border-radius: 12px;
}

.cropper-wrapper {
	width: 100%;
	max-height: 400px;
	overflow: hidden;
}

.cropper-view-box,
.cropper-face {
	border: 2px solid #ffffff !important;
	box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.55);
}

.cropper-line,
.cropper-point {
	background-color: #ffffff !important;
}

.cropper-actions {
	background-color: #ffffff !important;
	box-shadow: unset !important;
	padding: 12px;

	&__slider {
		.v-input__slot {
			height: 22px !important;
		}

		.v-slider,
		.v-input {
			margin: 12px 0 !important;
			min-height: 36px;
		}

		.v-input__slot {
			height: 26px !important;
			align-items: center !important;
		}

		.v-slider__track-container {
			height: 3px !important;
			border-radius: 4px;
		}

		.v-slider__thumb {
			width: 18px !important;
			height: 18px !important;
			border: 2px solid #fff !important;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
			background: var(--accent-color, #19406e) !important;
		}

		.v-slider__thumb::after {
			width: 12px !important;
			height: 12px !important;
		}

		.v-slider__thumb:before {
			display: none;
		}

		.v-slider__track-fill {
			background-color: var(--accent-color, #19406e) !important;
		}

		.v-slider__track-background {
			background-color: #e3ecfa !important;
		}

		.v-label {
			font-family: 'Inter', sans-serif;
			color: #4a4a4a;
			font-weight: 500;
			font-size: 18px;
			line-height: 100%;
			min-width: 110px;
			margin-right: 3px;
		}

		.v-messages,
		.v-slider__ticks,
		.v-input__append-outer,
		.v-input__prepend-outer {
			display: none !important;
		}
	}

	&__buttons {
		display: flex;
		justify-content: center;
		gap: 12px;

		&__close,
		&__save {
			width: 150px;
			height: 46px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
		}

		&__close {
			background-color: #ffffff;
			color: var(--accent-color);
			border: 1px solid var(--accent-color);
		}

		&__save {
			background-color: var(--accent-color);
			color: #ffffff;
			border: 1px solid var(--accent-color);
		}
	}
}
</style>
